import { FormEventHandler, FunctionComponent, useContext, useEffect } from "react";
import InputEmail from "../generic/InputEmail";
import SubmitButton from "../generic/SubmitButton";
import { UserContext } from "../layout/Layout";
import TransitionLink from "../transition/TransitionLink";
import UserApi from "../../api/UserApi";
import { ROUTE_NAME } from "../routing/Routing";
import useIsMounted from "../customHooks/useIsMounted";

const userApi = new UserApi();

const ForgotPassword: FunctionComponent = () => {
    const { animatedRoutesBegin, animatedRoutesEnd } = useContext(UserContext);
    const { isComponentMounted } = useIsMounted();

    const isValidForm = (target: EventTarget & HTMLFormElement): boolean => {
        const inputKeys = ["email"];
        for (let i = 0; i < inputKeys.length; i++) {
            const inputKey = inputKeys[i];
            if (target[inputKey].classList.contains("invalid")) {
                return false;
            }; 
        };
        return true;
    };

    const submit: FormEventHandler<HTMLFormElement> = async (e) => {
        e.preventDefault();
        const target = e.currentTarget;
        const email = target.email.value;
        if (isValidForm(target) && email.length > 0) {
            const userAlertMsg = target.userAlertMsg;
            const submitButton = target.forgotPasswordSubmitButton;
            userAlertMsg.classList.remove("active");
            submitButton.disabled = true;
            try {
                await userApi.forgotPassword(email)
                if (isComponentMounted()) {
                    animatedRoutesBegin(ROUTE_NAME.FORGOT_PASSWORD_SUBMIT);
                };
            } catch (error) {
                const errorMsg = userApi.checkAPIError(error);
                if (isComponentMounted()) {
                    submitButton.disabled = false;
                    userAlertMsg.value = errorMsg.msg;
                    userAlertMsg.classList.add("active");
                };
            };
        };
    };

    const enabledForm: FormEventHandler<HTMLFormElement> = (e) => {
        const target = e.currentTarget;
        const submitButton = target.forgotPasswordSubmitButton;
        if (submitButton.classList.contains("d-none")) {
            submitButton.classList.remove("d-none");
            submitButton.classList.add("submitButton");
            submitButton.type = "submit";
        };
    };

    useEffect(() => {
        animatedRoutesEnd();
    }, [animatedRoutesEnd]);

    return (
        <>
            <h1 className="title1">Mot de passe oublié</h1>
            <span className="largeBorder"></span>
            <form className="form" onSubmit={submit} onChange={enabledForm}>
                <InputEmail inputLabel="Veuillez renseigner votre adresse mail" inputId="email" inputName="email" isRequired={true} inputPLaceholder="Email*" />
                <TransitionLink to="/login" className="inputHelp link">Retour à la page de connexion</TransitionLink>
                <input type="text" name="userAlertMsg" className="alert" />
                <SubmitButton buttonId="forgotPasswordSubmitButton" buttonLabel="Valider" classname="d-none" />
            </form>
        </>
    );
};

export default ForgotPassword;